import $ from 'jquery';
import { initPasswordField } from 'stdjs/form';
import { standardAjaxPost } from 'stdjs/standard-ajax';

$(document).ready(function(){
    
    initPasswordField( '#LOGIN_PASSWORD' );	
    
    $("#LOGIN_EMAIL").keypress(function(event) {
        
        if(event.keyCode === 13) {
            event.preventDefault();
            $("#LOGIN_PASSWORD").focus();
            return false;
        }

    });

    $("#LOGIN_PASSWORD").keypress(function(event) {

        if(event.keyCode === 13) {
            event.preventDefault();
            $("#LOGIN_SUBMIT").trigger("click");
            return false;
        }

    });
    
    $("#LOGIN_SIGNUP").click(function(event) {

        event.preventDefault();

        location.href = signUpUrl;

        return false;

    });

    $("#LOGIN_SUBMIT").click(function(event) {

        event.preventDefault();

        var url = signInSubmitUrl;
        var data = $("#LOGIN").serialize();
        var successCallback = function(data){
            location.href = data.href;
        }
        
        standardAjaxPost(url, data, successCallback);

        return false;

    });
    
    $("#LOGIN_EMAIL").trigger("focus");
});
